import { render } from "./IconTrigger.vue?vue&type=template&id=40275dcb"
import script from "./IconTrigger.vue?vue&type=script&lang=js"
export * from "./IconTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script